import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type ProductDetail } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    { id, reviewSize, ...data }: ProductDetail.Api.InitRequest
  ): Promise<HttpApiResponse<ProductDetail.Api.InitResponse | null>> =>
    api.get(apiInfo, `/api/site/v1/modules/productDetail/${id}`, {
      ...data,
      page: 1,
      size: reviewSize,
      sortBy: "CreatedOnDate",
      order: "DESC"
    }),

  addReview: (
    apiInfo: ModuleApiInfo,
    id: string,
    data: ProductDetail.Api.AddProductReviewRequest
  ): Promise<HttpApiResponse<ProductDetail.Api.ProductReview>> =>
    api.post(apiInfo, `/api/site/v1/modules/productDetail/${id}/reviews`, data),
  getReviews: (
    apiInfo: ModuleApiInfo,
    id: string,
    data: ProductDetail.Api.GetProductReviewsRequest
  ): Promise<HttpApiResponse<ProductDetail.Api.GetProductReviewsResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/productDetail/${id}/reviews`, data),
  updateReview: (
    apiInfo: ModuleApiInfo,
    id: string,
    data: ProductDetail.Api.UpdateProductReviewRequest
  ): Promise<HttpApiResponse<ProductDetail.Api.ProductReview>> =>
    api.put(apiInfo, `/api/site/v1/modules/productDetail/${id}/reviews`, data)
};
